module.exports = __webpack_public_path__ + "static/media/Avatars_Other-30.22695d48.png";